import {getClient} from './getClient'

export const clients = {
  getClient,
}
